import React__default from 'react';
import classnames from 'classnames';
import { Manager, Reference } from 'react-popper';
import { TooltipContent } from './components/TooltipContent.js';
import { TooltipMessage } from './components/TooltipMessage.js';
import { TooltipTrigger } from './components/TooltipTrigger.js';
import { isTouchDevice } from '../Util/is-touch-device.js';

const Tooltip = ({ id , message , className , placement , boundariesElement , label , renderLabel , 'aria-label': ariaLabel , iconName , theme  })=>{
    const [isActive, setIsActive] = React__default.useState(false);
    const isTouch = React__default.useMemo(isTouchDevice, []);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('tooltip', className)
    }, /*#__PURE__*/ React__default.createElement(Manager, null, /*#__PURE__*/ React__default.createElement(Reference, null, ({ ref  })=>/*#__PURE__*/ React__default.createElement(TooltipTrigger, {
            id: id,
            "aria-label": ariaLabel,
            isTouch: isTouch,
            ref: ref,
            isActive: isActive,
            setIsActive: setIsActive,
            iconName: iconName,
            theme: theme,
            renderLabel: renderLabel,
            label: label
        })
    ), /*#__PURE__*/ React__default.createElement(TooltipContent, {
        id: id,
        isActive: isActive,
        setIsActive: setIsActive,
        placement: placement,
        boundariesElement: boundariesElement
    }, /*#__PURE__*/ React__default.createElement(TooltipMessage, {
        message: message
    }))));
};
var Tooltip$1 = Tooltip;

export { Tooltip$1 as default };
//# sourceMappingURL=Tooltip.js.map
